Vendd.Scripts.load(function () {
    var $wrapper = $('.x-cart-related-product-list'),
        wrapper;

    var model = null;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading (loading) {
        if (loading === true) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function() {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("cartRelatedProductList_A", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind (html) {
        $wrapper.html(html);

        Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

        var options = {
            slides: '> *',
            timeout: 5000,
            speed: 850,
            fx: 'scrollHorz',
            log: false,
            prev: $('.prev', $wrapper),
            next: $('.next', $wrapper),
            pager: $('.pager', $wrapper),
            pagerTemplate: '<span></span>',
            pauseOnHover: true
        };

        var $cycle = $('.cycle-wrapper', $wrapper);

        if ($cycle.children().length > 1) {
            $cycle.cycle(options);
        } else {
            $cycle.addClass('no-cycle');
        };
    };

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.CartRelatedProducts;
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, wrapper, function (envelope) {
        wrapper.loading(false);
    });
});